<div class="logout-container">
  <div class="logout-div">
    Logging out ...
  </div>
</div>
